import React, { useEffect, useState } from 'react';
import Helmet from 'react-helmet';

export const MetaMaker = (props) => {
  const { pageTitle, metaDescription, descriptionLocation, descriptionJob, isTitleCustom, isCustomDescription } = props;

  const [descriptionTemplate, setDescriptionTemplate] = useState("");

  useEffect(() => {
    let tempDescription = "";

    if ((descriptionJob && descriptionJob !== undefined) || (descriptionLocation && descriptionLocation !== undefined)) {
      tempDescription += "Apply to" + (descriptionJob ? " " + descriptionJob : "");
      tempDescription += " jobs available" + (descriptionLocation ? " in " + descriptionJob : "");
      tempDescription += " on iQor Careers, global provider of customer care and interactions, and Business Process Outsourcing (BPO) solutions.";
    } else {
      tempDescription = "Jobs: one search. all jobs. iQor Careers job search. Find millions of jobs from thousands of job boards, newspapers, classifieds and company websites on iQor Careers.";
    }
    

    setDescriptionTemplate(tempDescription);
  }, [descriptionLocation, descriptionJob]);

  return (
    <>
      <Helmet>
        {
          isTitleCustom ? (
            <title>{pageTitle}</title>
          ) : (
              <title>{sessionStorage.getItem('appTitle') ? sessionStorage.getItem('appTitle') + " | " + pageTitle : "Voya PHL Careers" + " | " + pageTitle}</title>
              )
        }

        {
          !isCustomDescription ? (
            <meta name="description" content={descriptionTemplate } />
          ): (
              <meta name="description" content={ metaDescription } />
            )
        }
      </Helmet>
    </>
    )
}
